import { render, staticRenderFns } from "./MColumnSetting.vue?vue&type=template&id=051cbe08&scoped=true"
import script from "./MColumnSetting.vue?vue&type=script&lang=js"
export * from "./MColumnSetting.vue?vue&type=script&lang=js"
import style0 from "./MColumnSetting.vue?vue&type=style&index=0&id=051cbe08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051cbe08",
  null
  
)

export default component.exports